<p>pos-on-screen-check-footer works!</p>
